import React from 'react';
import { HashRouter, Route, Redirect, Switch } from 'react-router-dom';

// import FrontendAuth from './frontend-auth';  //路由守卫高阶组件

// 基础路由
import NotPage from '../views/404/lazy';
import maintain from '../views/404/maintain';
import Login from '../views/login/lazy';
// import Home from '../views/home';
import routerMap from './router-map';  //路由表


const RouterComponent = (props) => {
    return (
        <HashRouter history={props.history}>
            <Switch>
                <Redirect exact from='/' to='/login' />
                <Route exact path='/login' component={Login} />
                <Route exact path='/maintain' component={maintain} />
                <Redirect exact from='/home' to='/home/index' />
                {routerMap}
                <Route component={NotPage} />
            </Switch>
        </HashRouter>
    );
};


export default RouterComponent;
